import classNames from "classnames";

export interface HeaderProps {
  children?: React.ReactNode;
  className?: string;
}

export const Header = ({ children, className, ...rest }: HeaderProps) => (
  <nav
    className={classNames(
      "bg-primary flex h-full max-h-16 w-full items-center justify-between px-6 py-4",
      className,
    )}
    {...rest}
  >
    {children}
  </nav>
);
